import { createSlice } from '@reduxjs/toolkit'

import { initialState } from './constants'
import { init } from './helpers'
import { getTranslationsThunk } from './thunks'

const translationSlice = createSlice({
  name: 'translation',
  initialState,
  reducers: {
    setTranslationsReady: (state) => {
      state.ready = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTranslationsThunk.fulfilled, (state, action) => {
      state.data = action.payload
      init(state.data)
    })
  },
})

export const { setTranslationsReady } = translationSlice.actions
export default translationSlice.reducer
